<template>
    <div class="section-counter paralax-mf bg-image" style="background-image: url(images/intro-bg.webp)">
    <div class="overlay-mf"></div>
    <div class="container">
      <div class="row">
        <div class="col-sm-4 col-lg-4">
          <div class="counter-box pt-4 pt-md-0">
            <div class="counter-ico">
              <span class="ico-circle"><i class="fas fa-calendar"></i></span>
            </div>
            <div class="counter-num">
              <p class="counter">25</p>
              <span class="counter-text">ANOS</span>
            </div>
          </div>
        </div>
        <div class="col-sm-4 col-lg-4">
          <div class="counter-box pt-4 pt-md-0">
            <div class="counter-ico">
              <span class="ico-circle"><i class="fas fa-users"></i></span>
            </div>
            <div class="counter-num">
              <p class="counter">46000<span>+</span></p>
              <span class="counter-text">CLIENTES SATISFEITOS</span>
            </div>
          </div>
        </div>
        <div class="col-sm-4 col-lg-4">
          <div class="counter-box pt-4 pt-md-0">
            <div class="counter-ico">
              <span class="ico-circle"><i class="fas fa-award"></i></span>
            </div>
            <div class="counter-num">
              <p class="counter">12000<span>+</span></p>
              <span class="counter-text">PROJETOS REALIZADOS</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div> 
</template>
<script>


export default {
    
}
</script>
